import React, {useEffect, useState} from 'react';
import {apiUrl} from "../../../libs/api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClose
} from "@fortawesome/free-solid-svg-icons";
import Reader from "../../../libs/lexical/Reader";
import "./AnnouncementMessage.scss"

const typeMessagesInit = {
    loading : true,
    data : {
        _id : null,
        text : "",
        links : []
    },
    init : false,
    toggle : false
}

export const AnnouncementMessage = ({
         role =  "guest"
     }) => {
    const [state, setState] = useState(typeMessagesInit);

    useEffect((state) => {
        const fetchData = async () => {
            try {
                let result = await apiUrl.get(`/announcement-messages/right/${role}`);
                if(result.data && role === "guest"){
                    result = result.data;
                }

                let data = result._id ? result : state.data;
                let toggle = sessionStorage.getItem(`${process.env.REACT_APP_TOKEN_NAME}_announcementMessage_${data._id}`) ? false : true
                setState({
                    loading: false,
                    data,
                    init: true,
                    toggle
                })
            }
            catch (e){
                setState({
                    ...typeMessagesInit,
                    loading: false,
                    init: true,
                    toggle: false
                })
            }
        }
        fetchData();
    }, [role]);

    function _closeAnnouncementMessage(){
        sessionStorage.setItem(`${process.env.REACT_APP_TOKEN_NAME}_announcementMessage_${state.data._id}`, true);
        setState({...state, toggle: false});

    }


    return state.toggle ? (
        <div className="announcement-message-wrapper">
            <div className="announcement-message">
                <div className="announcement-message-content">
                    <Reader text={state.data.text} meta={{
                        link : state.data.links
                    }}/>
                </div>
                <div className='announcement-message-close' onClick={()=>_closeAnnouncementMessage()}  ><FontAwesomeIcon icon={faClose} /></div>
            </div>
        </div>
    ) : null


};
export default AnnouncementMessage;